import { render } from "./imageButtonCheck.vue?vue&type=template&id=5fecacd6"
import script from "./imageButtonCheck.vue?vue&type=script&lang=js"
export * from "./imageButtonCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__